import React, { useState } from 'react';
import styled from '@emotion/styled';
import { AccordionPanel } from '@/src/components/accordion/AccordionPanel'
import { BlockGroupList } from '@/src/components/list/BlockGroupList/BlockGroupList';
import { useToggle } from 'react-use';
import { BinIcon } from '@/src/components/icon/BinIcon';
import { Modal } from 'antd';
import { PureBlockGroupPropsForm, useBlockGroupPropsForm } from '@/src/components/form/BlockGroupPropsForm';
import { useEditorContext } from '@/src/context/EditorContext';

export function BlockGroupSelectPanel() {
  const [isVisible, toggle] = useToggle(false);
  const {
    appendBlockGroup,
  } = useEditorContext();
  const blockGroupPropsFormState = useBlockGroupPropsForm();
  const {
    Container
  } = S;
  return (
    <Container>
      <AccordionPanel
        id="BlockGroupSelectPanel"
        title="色块组"
        actionRender={() => (
          <BinIcon
            type={"add_file"}
            size={16}
            onClick={() => {
              toggle(true);
            }}
          />
        )}
      >
        <BlockGroupList />
      </AccordionPanel>
      <Modal
        visible={isVisible}
        onCancel={toggle}
        title="添加色块组"
        onOk={() => {
          const {
            name,
            groupWidth,
            groupHeight,
            blockSize,
          } = blockGroupPropsFormState;
          appendBlockGroup(
            `${name} (${groupWidth}x${groupHeight})`,
            groupWidth,
            groupHeight,
            blockSize,
          );
          toggle();
          blockGroupPropsFormState.setName("");
        }}
      >
        <PureBlockGroupPropsForm {...blockGroupPropsFormState} />
      </Modal>
    </Container>
  );
}

BlockGroupSelectPanel.id = 'BlockGroupSelectPanel';
const S = {
  Container: styled.div``,
}
